import React from "react";
import ProfileMenuContent from "./ProfileMenuContent";
import InlineMainMenu from "./InlineMainMenu";

const InlineProfileMenu = ({ mobileMenuProfileDrawer, setMobileMenuProfileDrawer }) => {

  return (
    <>
      <div onClick={() => setMobileMenuProfileDrawer(prev => prev = !mobileMenuProfileDrawer)} className={`fullmenu-backdrop ${mobileMenuProfileDrawer ? "active" : ""}`}></div>
      <nav className={`fullmenu profile-menu header-bk-color ${mobileMenuProfileDrawer ? 'active' : ""}`}>
        {/* <ProfileMenuContent setMobileMenuProfileDrawer={setMobileMenuProfileDrawer} mobileMenuProfileDrawer={mobileMenuProfileDrawer}/> */}
        {
          mobileMenuProfileDrawer ?
            <InlineMainMenu toggleMobileMenu={mobileMenuProfileDrawer} setMobileMenuProfileDrawer={setMobileMenuProfileDrawer} /> : null
        }
      </nav>
    </>
  );
};

export default InlineProfileMenu;

